<template>
  <div class="wrapper">
    <filters />
    <a-empty
      v-if="!loading && results.length === 0"
      description="Brak materiałów dydaktycznych"
    />

    <a-list
      v-else
      class="list"
      :loading="loading"
      itemLayout="horizontal"
      :pagination="pagination"
      :dataSource="results"
    >
      <a-collapse :bordered="false">
        <a-collapse-panel
          v-for="course in results"
          :key="course.id"
          :header="course.name"
        >
          <course-materials-view class="materials" :courseId="course.id" />
        </a-collapse-panel>
      </a-collapse>
    </a-list>
  </div>
</template>

<script>
import CourseList from '@/views/ExtendableBases/CourseList/'
import CourseMaterialsView from '@/views/AdminPanel/Course/Details/Materials/'

export default {
  extends: CourseList,
  components: {
    CourseMaterialsView
  }
}
</script>

<style lang="scss" scoped>
.list {
  margin-top: 40px;
}
</style>
